import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import logo from '../images/polymedia-citrus.png';
import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js'


class Quickpoll extends React.Component {

  constructor(props) {
    super(props);

    let embed_interface = false;
    let poll_language = "NL";
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_embed = params.get('embed');
      let param_lang = params.get('lang');
      if(param_embed === "") {
        embed_interface = true;
      }
      if(param_lang && param_lang.trim() !== "" && param_lang.toLowerCase() === "en") {
        poll_language = "EN";
      }
    }
    document.documentElement.setAttribute('lang', poll_language.toLowerCase());

    const checkCookie = this.getCookie(props.match.params.id);
    this.state = {
      selected: checkCookie ? checkCookie : "",
      cookie: checkCookie,
      embed_interface: embed_interface,
    };
  }

  componentWillMount() {
    this.props.fetchDataIfReady(config.api_token, "quickpoll_"+this.props.match.params.id, "GET", config.api_url+"/quickpoll/"+this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    this.props.fetchDataIfReady(config.api_token, "quickpoll_"+nextProps.match.params.id, "GET", config.api_url+"/quickpoll/"+nextProps.match.params.id);
  }

  render() {
    const api_quickpoll = this.props.apiData["quickpoll_"+this.props.match.params.id];
    if(api_quickpoll === undefined || api_quickpoll.isFetching) {
      return <div>Loading Quickpoll..</div>;
    } else if(api_quickpoll.data.length === 0) {
      return <div>Failed to load Quickpoll.</div>;
    }

    const quickpoll = this.props.apiData["quickpoll_"+this.props.match.params.id].data;
    document.title = "Citrus Poll · "+quickpoll.name+" · Citrus by Polymedia";
    const quickpoll_options = quickpoll.options.map(function(item, i) {
      let cN = null;
      if(this.state.selected !== "") {
        let voted = this.state.cookie ? " voted" : "";
        cN = (this.state.selected === item ? "active" : "inactive") + voted;
      }
      return <button key={i} onClick={!this.state.cookie ? () => this.vote(item) : null} className={cN} style={{border:"0"}} title={item}><span>{item}</span></button>;
    }.bind(this));

    import('../poll.css');
    return (
      <div style={(!this.state.embed_interface) ? {padding:"1em", background:"#f5f5f5", minHeight:"100vh"} : null}>
        <div className="poll" style={(!this.state.embed_interface) ? {margin:"2em auto", maxWidth:"700px"} : null}>
          <div className="poll-header" style={(!this.state.embed_interface) ? {textAlign:"center", fontSize:"150%", margin:"0 auto", maxWidth:"700px", background:"#fff", borderTopLeftRadius:"7px", borderTopRightRadius:"7px"} : {textAlign:"center", fontSize:"150%"}}><div style={{wordBreak:"break-all", width:"100%"}}>{quickpoll.name}</div><div style={(!this.state.embed_interface) ? {display:"none"} : {position:"absolute", right:"16px"}}><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" style={{marginTop:"-3px"}} /></a></div><br style={{clear:"both"}}/></div>
          <div className="poll quickpoll" style={(!this.state.embed_interface) ? {maxWidth:"700px"} : null}>
            <div className="poll-body">
              {quickpoll_options}
            </div>
          </div>
          {this.state.cookie && <div style={{textAlign:"center"}}>Bedankt voor jouw stem!</div>}
        </div>
        {!this.state.embed_interface && <div className="logo-footer"><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div>}
      </div>
    );
  }


  vote = label => {
    this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/vote", JSON.stringify({id:this.props.match.params.id, label, type:"qp"}), null, true);
    document.cookie = this.props.match.params.id+"="+label+"; path=/";
    this.setState({cookie:this.getCookie(this.props.match.params.id), selected:label});
  };

  getCookie = cname => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

}


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Quickpoll)



// WEBPACK FOOTER //
// ./src/containers/Quickpoll.js